import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

const backendOptions = {
  loadPath: '/translations/{{lng}}.json'
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    backend: backendOptions,
    debug: process.env.REACT_APP_MODE === 'development',
    interpolation: {
      escapeValue: false
    },
    whitelist: ['en', 'es'],
    load: 'currentOnly',
    preload: ['en', 'es']
  });


export const availableLanguages = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Castellano'},
]

export default i18n;